const formEquipmentActions = {
  notFoundActions: 'No action found',
  loadMoreButtonText: 'Show more',
};

export default formEquipmentActions;
